export const STREAMERS_CREATOR_FEED_TEST = [
  'bl3ssur',
  'xamork',
  'ayami2059',
  'sandra_tv',
  'indiechoi',
  'lucybellhaner',
  'heartwood',
];
